<template>
    <AuthLayout v-bind="appSharedData.getAuthLayoutProps()">
        <template #title> Select a company </template>

        <template #card-content>
            <div class="space-y-2">
                <template
                    v-for="company in localCompanies"
                    :key="company.id.value"
                >
                    <CompanyCard
                        :company="company"
                        :destinationUrl="destinationUrl"
                    />
                </template>
            </div>
        </template>
    </AuthLayout>
</template>

<script setup lang="ts">
    import Company from '@/App/Company/Entity/Company'
    import AuthLayout from '@/Shared/Layout/App/Auth/AuthLayout.vue'
    import CompanyCard from '@/App/User/Component/Login/CompanyCard.vue'
    import AppSharedData from '@/Shared/Entity/AppSharedData'

    interface ShowCompanySelectionProps {
        appSharedDataData: any
        companiesData: any
        destinationUrl: string
    }

    const props = defineProps<ShowCompanySelectionProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const localCompanies = Company.hydrateMultiple(props.companiesData)
</script>
